import { Stack, Typography } from '@mui/material';
import { Box, styled } from '@mui/system';

const Label = styled(Typography)({
  fontWeight: 500,
});

const Container = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100vh',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: theme.palette.background.default,
}));

const AnimationBackground = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 0,
});

const Wrapper = styled(Box)(({ theme }) => ({
  height: '100%',
  position: 'relative',
  backgroundColor: theme.palette.background.default,
  borderImage: `repeating-linear-gradient(180deg,${theme.palette.border.default} 0,${theme.palette.border.default} 4px,transparent 0,transparent 8px) 1`,
  borderLeft: `1px dashed ${theme.palette.border.default}`,
  borderRight: `1px dashed ${theme.palette.border.default}`,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: 600,
  },
  justifySelf: 'center',
}));

const Body = styled(Stack)(({ theme }) => ({
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
}));

export { Container, AnimationBackground, Label, Wrapper, Body };
